var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan0, _tspan1, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14, _tspan15, _tspan16, _tspan17, _tspan18, _tspan19, _tspan20, _tspan21, _tspan22, _tspan23, _tspan24, _tspan25, _tspan26, _tspan27, _tspan28, _tspan29, _tspan30, _tspan31, _tspan32, _tspan33, _tspan34, _tspan35, _tspan36, _tspan37, _tspan38, _tspan39, _tspan40, _tspan41, _tspan42, _tspan43;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGaugeValue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 189,
    viewBox: "0 0 260 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Retirement readiness score"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 12830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 12824"
  }, /*#__PURE__*/React.createElement("text", {
    id: 0,
    fill: "#576268",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 12,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 6,
    y: 181.11
  }, "0"))), /*#__PURE__*/React.createElement("text", {
    id: 50,
    fill: "#576268",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 12,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 92.11
  }, "50"))), /*#__PURE__*/React.createElement("text", {
    id: 100,
    fill: "#576268",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 12,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 55,
    y: 11.11
  }, "100"))), /*#__PURE__*/React.createElement("text", {
    id: 125,
    fill: "#576268",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 12,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 173,
    y: 11.11
  }, "125"))), /*#__PURE__*/React.createElement("text", {
    id: 150,
    fill: "#576268",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 12,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 235,
    y: 96.11
  }, "150"))), /*#__PURE__*/React.createElement("text", {
    id: "150+",
    fill: "#576268",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 12,
    fontWeight: 500,
    letterSpacing: "0em"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 231,
    y: 179.11
  }, "150+")))), /*#__PURE__*/React.createElement("g", {
    id: "Group 12829"
  }, /*#__PURE__*/React.createElement("text", {
    id: "G",
    transform: "translate(113 36.8489) rotate(-19.3373)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "G"))), /*#__PURE__*/React.createElement("text", {
    id: "o",
    transform: "translate(119.643 34.5054) rotate(-5.8012)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "o"))), /*#__PURE__*/React.createElement("text", {
    id: "o_2",
    transform: "translate(125.639 34.0723) rotate(7.09035)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "o"))), /*#__PURE__*/React.createElement("text", {
    id: "d",
    transform: "translate(131.676 35.1934) rotate(19.9819)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan0 || (_tspan0 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "d")))), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("text", {
    id: "V",
    transform: "translate(169.934 52.3279) rotate(19.4027)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan1 || (_tspan1 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "V"))), /*#__PURE__*/React.createElement("text", {
    id: "e",
    transform: "translate(176.451 55.2202) rotate(29.6934)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "e"))), /*#__PURE__*/React.createElement("text", {
    id: "r",
    transform: "translate(181.879 58.8896) rotate(39.0039)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "r"))), /*#__PURE__*/React.createElement("text", {
    id: "y",
    transform: "translate(185.791 61.9106) rotate(48.3145)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "y"))), /*#__PURE__*/React.createElement("text", {
    id: "g",
    transform: "translate(192.314 70.5063) rotate(64.9755)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "g"))), /*#__PURE__*/React.createElement("text", {
    id: "o_3",
    transform: "translate(194.609 76.0208) rotate(74.7761)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "o"))), /*#__PURE__*/React.createElement("text", {
    id: "o_4",
    transform: "translate(195.934 81.5537) rotate(84.5767)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "o"))), /*#__PURE__*/React.createElement("text", {
    id: "d_2",
    transform: "translate(196.768 87.6218) rotate(94.3773)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "d")))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "E",
    transform: "translate(204.045 110.234) rotate(87.103)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "E"))), /*#__PURE__*/React.createElement("text", {
    id: "x",
    transform: "translate(204.988 116.001) rotate(86.54)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "x"))), /*#__PURE__*/React.createElement("text", {
    id: "c",
    transform: "translate(205.623 122.341) rotate(92.9559)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "c"))), /*#__PURE__*/React.createElement("text", {
    id: "e_2",
    transform: "translate(205.596 129.223) rotate(97.8081)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "e"))), /*#__PURE__*/React.createElement("text", {
    id: "l",
    transform: "translate(204.188 135.682) rotate(107.339)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "l"))), /*#__PURE__*/React.createElement("text", {
    id: "l_2",
    transform: "translate(203.127 139.169) rotate(110.617)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "l"))), /*#__PURE__*/React.createElement("text", {
    id: "e_3",
    transform: "translate(202.295 142.458) rotate(119.694)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "e"))), /*#__PURE__*/React.createElement("text", {
    id: "n",
    transform: "translate(199.283 147.744) rotate(121.807)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "n"))), /*#__PURE__*/React.createElement("text", {
    id: "t",
    transform: "translate(195.391 152.967) rotate(131.527)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "t")))), /*#__PURE__*/React.createElement("g", {
    id: "Group 12828"
  }, /*#__PURE__*/React.createElement("text", {
    id: "N",
    transform: "translate(34.1602 155.01) rotate(-98.9816)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "N"))), /*#__PURE__*/React.createElement("text", {
    id: "e_4",
    transform: "translate(32.5723 147.678) rotate(-96.4749)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "e"))), /*#__PURE__*/React.createElement("text", {
    id: "e_5",
    transform: "translate(31.8613 141.695) rotate(-94.0876)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "e"))), /*#__PURE__*/React.createElement("text", {
    id: "d_3",
    transform: "translate(31.1484 136.066) rotate(-91.7003)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan29 || (_tspan29 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "d"))), /*#__PURE__*/React.createElement("text", {
    id: "s",
    transform: "translate(31.3145 130.693) rotate(-89.313)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan30 || (_tspan30 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "s"))), /*#__PURE__*/React.createElement("text", {
    id: "a",
    transform: "translate(43 162.889) rotate(-100.246)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan31 || (_tspan31 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "a"))), /*#__PURE__*/React.createElement("text", {
    id: "t_2",
    transform: "translate(43 156.367) rotate(-97.9785)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan32 || (_tspan32 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "t"))), /*#__PURE__*/React.createElement("text", {
    id: "t_3",
    transform: "translate(42 151.157) rotate(-95.8299)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan33 || (_tspan33 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "t"))), /*#__PURE__*/React.createElement("text", {
    id: "e_6",
    transform: "translate(42 146.263) rotate(-93.5619)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan34 || (_tspan34 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "e"))), /*#__PURE__*/React.createElement("text", {
    id: "n_2",
    transform: "translate(42 140.714) rotate(-91.1746)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan35 || (_tspan35 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "n"))), /*#__PURE__*/React.createElement("text", {
    id: "t_4",
    transform: "translate(42 135.359) rotate(-88.9067)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan36 || (_tspan36 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "t"))), /*#__PURE__*/React.createElement("text", {
    id: "i",
    transform: "translate(42 130.888) rotate(-86.9968)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan37 || (_tspan37 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "i"))), /*#__PURE__*/React.createElement("text", {
    id: "o_5",
    transform: "translate(42 128.101) rotate(-84.9676)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan38 || (_tspan38 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "o"))), /*#__PURE__*/React.createElement("text", {
    id: "n_3",
    transform: "translate(42 121.958) rotate(-82.5803)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan39 || (_tspan39 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "n")))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "F",
    transform: "translate(54.6367 70.517) rotate(-62.2905)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan40 || (_tspan40 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "F"))), /*#__PURE__*/React.createElement("text", {
    id: "a_2",
    transform: "translate(57.2949 64.7919) rotate(-56.1517)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan41 || (_tspan41 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "a"))), /*#__PURE__*/React.createElement("text", {
    id: "i_2",
    transform: "translate(60.6738 60.0575) rotate(-50.9336)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan42 || (_tspan42 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "i"))), /*#__PURE__*/React.createElement("text", {
    id: "r_2",
    transform: "translate(63.1133 57.7555) rotate(-46.0226)",
    fill: "#777373",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Rubik",
    fontSize: 8,
    letterSpacing: "0em"
  }, _tspan43 || (_tspan43 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 7.24
  }, "r")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaugeValue);
export default __webpack_public_path__ + "static/media/gaugeValue.88eb71f074b78ea0acce86abbb67e791.svg";
export { ForwardRef as ReactComponent };